import colors from 'assets/styles/colors';
import { baseCheckboxStyles } from 'features/targetingV2/styles/checkbox.styles';

import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  ...baseCheckboxStyles(theme),
  root: {
    flexGrow: 1,
    height: 'auto',
    '&--noMargin': {
      margin: 0,
    },
  },
  input: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    '&--externalLink': {
      paddingRight: theme.spacing(6.25),
    },
    border: `solid 1px ${theme.palette.grey[400]}`,
    padding: theme.spacing(0.43, 0.625),
    fontSize: '14px',
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'auto',
    gap: theme.spacing(0.5),
    maxHeight: '200px',
  },
  toggleMultiValuesBtnWrapper: {
    width: '100%',
  },
  toggleMultiValuesBtnText: {
    justifyContent: 'normal',
    height: '22px',
    lineHeight: 'initial',
  },
  dropdownIndicator: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  placeholder: {
    position: 'absolute',
    left: theme.spacing(0.25),
    bottom: theme.spacing(0.75),
    fontSize: '1em',
  },
  paper: {
    position: 'absolute',
    zIndex: 2,
    left: 0,
    right: 0,
  },
  optionsListWrapper: {
    padding: theme.spacing(1, 0),
  },
  selectAllLabel: {
    width: '100%',
    margin: 0,
    '&:hover, &:focus': {
      background: theme.palette.grey[200],
    },
  },
  optionLabel: {
    width: '100%',
    margin: 0,
    '&--focussed': {
      background: theme.palette.grey[200],
    },
  },
  optionLabelText: {
    fontSize: '16px',
  },
  optionCheckbox: {
    padding: theme.spacing(0, 0.5),
  },
  dividerWrapper: {
    margin: theme.spacing(0.25, 1),
  },
}));

export const customStyles = {
  dropdownIndicator: (provided: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
  }),
  clearIndicator: (provided: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  input: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  // So that if selected value is too long, it won't overflow the indicators. Ideal would be to set
  // max-width to (100% - indicatorsWidth), but haven't found a way to do that yet.
  singleValue: (provided: any) => ({
    ...provided,
    maxWidth: '80%',
  }),
  noOptionsMessage: (provided: any) => ({
    ...provided,
    color: colors.daxGreyscaleDarkGrey,
    textAlign: 'left',
    padding: '8px',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: colors.daxGreyscaleSilver,
  }),
};

export const asyncCustomStyles = {
  clearIndicator: (provided: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
  }),
  input: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  noOptionsMessage: (provided: any) => ({
    ...provided,
    color: colors.daxGreyscaleDarkGrey,
    textAlign: 'left',
    padding: '8px',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: colors.daxGreyscaleSilver,
    fontSize: '14px',
  }),
};
